import { Companion_getInstance2a03ktg5l3ejl as Companion_getInstance } from '../models/data.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstanceghpsqwa00d1o as Companion_getInstance_0 } from '../exceptions/handling.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_1,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__compareTo_impl_pchp0f3d3hhywzdbk51 as Duration__compareTo_impl_pchp0f,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance_2,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ReactiveLoadings35224pps2d9 as ReactiveLoading } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { DependencyChangeListener1518w8dt8yuu7 as DependencyChangeListener } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Key_getInstance2js7sv2agqob1 as Key_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineDispatcher.mjs';
import {
  CoroutineStart_DEFAULT_getInstance2bbgmtawlnkke as CoroutineStart_DEFAULT_getInstance,
  CoroutineStart_UNDISPATCHED_getInstance1s89xhsoy2cne as CoroutineStart_UNDISPATCHED_getInstance,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import {
  Monotonic_instance6v32gqtywf7e as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs1dlqois04h852 as ValueTimeMark__elapsedNow_impl_eonqvs,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/TimeSource.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Action(title, icon, clearErrorOnDependencyChange, keepRunningWhile, frequencyCap, ignoreRetryWhileRunning, action) {
  icon = icon === VOID ? Companion_getInstance().rcg_1 : icon;
  clearErrorOnDependencyChange = clearErrorOnDependencyChange === VOID ? Companion_getInstance_0().vcv_1 : clearErrorOnDependencyChange;
  keepRunningWhile = keepRunningWhile === VOID ? get_AppScope() : keepRunningWhile;
  var tmp;
  if (frequencyCap === VOID) {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance_1();
    tmp = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
  } else {
    tmp = frequencyCap;
  }
  frequencyCap = tmp;
  ignoreRetryWhileRunning = ignoreRetryWhileRunning === VOID ? true : ignoreRetryWhileRunning;
  var tmp_0;
  if (clearErrorOnDependencyChange) {
    tmp_0 = new (DependentAction())(title, icon, keepRunningWhile, ignoreRetryWhileRunning, VOID, action);
  } else {
    tmp_0 = new (RetryableAction())(title, icon, keepRunningWhile, ignoreRetryWhileRunning, VOID, action);
  }
  // Inline function 'kotlin.let' call
  var it = tmp_0;
  var tmp_1;
  var tmp_2 = frequencyCap;
  if ((tmp_2 == null ? null : new (Duration())(tmp_2)) == null) {
    tmp_1 = null;
  } else {
    var tmp_3 = frequencyCap;
    // Inline function 'kotlin.let' call
    var f = (tmp_3 == null ? null : new (Duration())(tmp_3)).nj_1;
    tmp_1 = new (FrequencyCapAction())(it, f);
  }
  var tmp1_elvis_lhs = tmp_1;
  return tmp1_elvis_lhs == null ? it : tmp1_elvis_lhs;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.core.reactiveState' call
  var tmp;
  try {
    var tmp_0 = $this.vd7_1.td7_1($this$launch, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = _ReactiveState___init__impl__fvdp9b(true);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof CancellationException()) {
      var _unused_var__etf5q3 = $p;
      tmp_1 = Companion_getInstance_2().mah_1;
    } else {
      if ($p instanceof ReactiveLoading()) {
        var _unused_var__etf5q3_0 = $p;
        tmp_1 = Companion_getInstance_2().mah_1;
      } else {
        if ($p instanceof Exception()) {
          var e = $p;
          tmp_1 = Companion_getInstance_2().uah(e);
        } else {
          throw $p;
        }
      }
    }
    tmp = tmp_1;
  }
  var result = tmp;
  $this.vd7_1.nai();
  $this.wd7_1._v = true;
  $this.vd7_1.sd7_1.pah(result);
  return Unit_instance;
}
var DependentAction$startAction$slambdaClass;
function DependentAction$startAction$slambda() {
  if (DependentAction$startAction$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $done) {
        this.vd7_1 = this$0;
        this.wd7_1 = $done;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DependentAction$startAction$slambdaClass = $;
  }
  return DependentAction$startAction$slambdaClass;
}
function DependentAction$startAction$slambda_0(this$0, $done) {
  var i = new (DependentAction$startAction$slambda())(this$0, $done);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var DependentActionClass;
function DependentAction() {
  if (DependentActionClass === VOID) {
    class $ extends DependencyChangeListener() {
      constructor(title, icon, keepRunningWhile, ignoreRetryWhileRunning, reportTo, action) {
        keepRunningWhile = keepRunningWhile === VOID ? get_AppScope() : keepRunningWhile;
        ignoreRetryWhileRunning = ignoreRetryWhileRunning === VOID ? false : ignoreRetryWhileRunning;
        reportTo = reportTo === VOID ? RawReactive().yah(_ReactiveState___init__impl__fvdp9b(false)) : reportTo;
        super();
        this.od7_1 = title;
        this.pd7_1 = icon;
        this.qd7_1 = keepRunningWhile;
        this.rd7_1 = ignoreRetryWhileRunning;
        this.sd7_1 = reportTo;
        this.td7_1 = action;
        this.ud7_1 = null;
      }
      ucv() {
        return this.od7_1;
      }
      gai() {
        this.sd7_1.pah(Companion_getInstance_2().mah_1);
      }
      fai() {
        this.sd7_1.pah(_ReactiveState___init__impl__fvdp9b(false));
      }
      xbe(scope) {
        var tmp;
        if (this.rd7_1) {
          var tmp0_safe_receiver = this.ud7_1;
          tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.za2()) === false;
        } else {
          tmp = false;
        }
        if (tmp)
          return Unit_instance;
        this.mai();
        var tmp1_safe_receiver = this.ud7_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.ma3();
        }
        var tmp_0 = this;
        var tmp2_elvis_lhs = this.qd7_1;
        // Inline function 'kotlin.let' call
        var tmp0 = tmp2_elvis_lhs == null ? scope : tmp2_elvis_lhs;
        var tmp$ret$0;
        $l$block_0: {
          var done = {_v: false};
          var tmp_1;
          var tmp0_safe_receiver_0 = tmp0.ea2().cd(Key_getInstance());
          if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.qa8(tmp0.ea2())) === false) {
            tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
          } else {
            tmp_1 = CoroutineStart_DEFAULT_getInstance();
          }
          var tmp_2 = tmp_1;
          var job = launch(tmp0, VOID, tmp_2, DependentAction$startAction$slambda_0(this, done));
          if (done._v) {
            tmp$ret$0 = null;
            break $l$block_0;
          } else {
            this.sd7_1.pah(Companion_getInstance_2().mah_1);
            tmp$ret$0 = job;
            break $l$block_0;
          }
        }
        tmp_0.ud7_1 = tmp$ret$0;
      }
      lai() {
        super.lai();
        var tmp0_safe_receiver = this.ud7_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this.ud7_1 = null;
          tmp0_safe_receiver.ma3();
        }
      }
      xd7() {
        return this.sd7_1.qah();
      }
      qah() {
        return this.xd7();
      }
      tah(listener) {
        return this.sd7_1.tah(listener);
      }
      iaj() {
        return this.sd7_1.iaj();
      }
    }
    initMetadataForClass($, 'DependentAction', VOID, VOID, [DependencyChangeListener(), Reactive()]);
    DependentActionClass = $;
  }
  return DependentActionClass;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.core.reactiveState' call
  var tmp;
  try {
    var tmp_0 = $this.fd8_1.dd8_1($this$launch, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = _ReactiveState___init__impl__fvdp9b(true);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof CancellationException()) {
      var _unused_var__etf5q3 = $p;
      tmp_1 = Companion_getInstance_2().mah_1;
    } else {
      if ($p instanceof ReactiveLoading()) {
        var _unused_var__etf5q3_0 = $p;
        tmp_1 = Companion_getInstance_2().mah_1;
      } else {
        if ($p instanceof Exception()) {
          var e = $p;
          tmp_1 = Companion_getInstance_2().uah(e);
        } else {
          throw $p;
        }
      }
    }
    tmp = tmp_1;
  }
  var result = tmp;
  $this.gd8_1._v = true;
  $this.fd8_1.cd8_1.pah(result);
  return Unit_instance;
}
var RetryableAction$startAction$slambdaClass;
function RetryableAction$startAction$slambda() {
  if (RetryableAction$startAction$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $done) {
        this.fd8_1 = this$0;
        this.gd8_1 = $done;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    RetryableAction$startAction$slambdaClass = $;
  }
  return RetryableAction$startAction$slambdaClass;
}
function RetryableAction$startAction$slambda_0(this$0, $done) {
  var i = new (RetryableAction$startAction$slambda())(this$0, $done);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var RetryableActionClass;
function RetryableAction() {
  if (RetryableActionClass === VOID) {
    class $ {
      constructor(title, icon, keepRunningWhile, ignoreRetryWhileRunning, reportTo, action) {
        keepRunningWhile = keepRunningWhile === VOID ? get_AppScope() : keepRunningWhile;
        ignoreRetryWhileRunning = ignoreRetryWhileRunning === VOID ? false : ignoreRetryWhileRunning;
        reportTo = reportTo === VOID ? RawReactive().yah(_ReactiveState___init__impl__fvdp9b(false)) : reportTo;
        this.yd7_1 = title;
        this.zd7_1 = icon;
        this.ad8_1 = keepRunningWhile;
        this.bd8_1 = ignoreRetryWhileRunning;
        this.cd8_1 = reportTo;
        this.dd8_1 = action;
        this.ed8_1 = null;
      }
      ucv() {
        return this.yd7_1;
      }
      xbe(scope) {
        var tmp;
        if (this.bd8_1) {
          var tmp0_safe_receiver = this.ed8_1;
          tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.za2()) === false;
        } else {
          tmp = false;
        }
        if (tmp)
          return Unit_instance;
        var tmp1_safe_receiver = this.ed8_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.ma3();
        }
        var tmp_0 = this;
        var tmp2_elvis_lhs = this.ad8_1;
        // Inline function 'kotlin.let' call
        var tmp0 = tmp2_elvis_lhs == null ? scope : tmp2_elvis_lhs;
        var tmp$ret$0;
        $l$block_0: {
          var done = {_v: false};
          var tmp_1;
          var tmp0_safe_receiver_0 = tmp0.ea2().cd(Key_getInstance());
          if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.qa8(tmp0.ea2())) === false) {
            tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
          } else {
            tmp_1 = CoroutineStart_DEFAULT_getInstance();
          }
          var tmp_2 = tmp_1;
          var job = launch(tmp0, VOID, tmp_2, RetryableAction$startAction$slambda_0(this, done));
          if (done._v) {
            tmp$ret$0 = null;
            break $l$block_0;
          } else {
            this.cd8_1.pah(Companion_getInstance_2().mah_1);
            tmp$ret$0 = job;
            break $l$block_0;
          }
        }
        tmp_0.ed8_1 = tmp$ret$0;
      }
      xd7() {
        return this.cd8_1.qah();
      }
      qah() {
        return this.xd7();
      }
      tah(listener) {
        return this.cd8_1.tah(listener);
      }
      iaj() {
        return this.cd8_1.iaj();
      }
    }
    initMetadataForClass($, 'RetryableAction', VOID, VOID, [Reactive()]);
    RetryableActionClass = $;
  }
  return RetryableActionClass;
}
var FrequencyCapActionClass;
function FrequencyCapAction() {
  if (FrequencyCapActionClass === VOID) {
    class $ {
      constructor(wraps, frequencyCap) {
        var tmp;
        if (frequencyCap === VOID) {
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance_1();
          tmp = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
        } else {
          tmp = frequencyCap;
        }
        frequencyCap = tmp;
        this.hd8_1 = wraps;
        this.id8_1 = frequencyCap;
        this.jd8_1 = Monotonic_instance.hj();
      }
      xbe(scope) {
        if (Duration__compareTo_impl_pchp0f(ValueTimeMark__elapsedNow_impl_eonqvs(this.jd8_1), this.id8_1) > 0) {
          this.jd8_1 = Monotonic_instance.hj();
          this.hd8_1.xbe(scope);
        }
      }
      ucv() {
        return this.hd8_1.ucv();
      }
      xd7() {
        return this.hd8_1.qah();
      }
      qah() {
        return this.xd7();
      }
      tah(listener) {
        return this.hd8_1.tah(listener);
      }
      iaj() {
        return this.hd8_1.iaj();
      }
    }
    initMetadataForClass($, 'FrequencyCapAction', VOID, VOID, [Reactive()]);
    FrequencyCapActionClass = $;
  }
  return FrequencyCapActionClass;
}
//region block: exports
export {
  Action as Action2nhdpxpznfsbd,
};
//endregion

//# sourceMappingURL=Action.mjs.map
